var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"guide-navigation-tile-small",attrs:{"to":_vm.routeTo}},[_c('div',{class:_vm.imageClassModifiers})])
}
var staticRenderFns = []

export { render, staticRenderFns }